import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'cs-icon-button',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './cs-icon-button.component.html',
  styleUrls: ['./cs-icon-button.component.scss'],
})
export class CSIconButtonComponent {
  /** 按钮图标的类型 */
  @Input() iconType: 'icon' | 'image' = 'icon';

  /** 按钮的图标 */
  @Input() icon = '';

  /** 按钮的尺寸 */
  @Input() size = '44';

  @Input() hasFrame = false;

  @Input() frameShape: 'circle' | 'square' = 'circle';

  /** 按钮的顏色 */
  @Input() color: 'primary' | 'secondary' | 'processes' | 'default' = 'primary';

  @Input() iconFontSize = '14px';

  @Input() disabled = false;

  @Output() buttonClick = new EventEmitter<MouseEvent>();

  handleClick(event: Event) {
    this.buttonClick.emit(event as MouseEvent);
  }
}
